/* eslint-disable camelcase */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-secrets/no-secrets */
/* eslint-disable object-shorthand */
/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
/* eslint-disable no-underscore-dangle */

import React, {
    useCallback,
    useContext,
    useEffect,
    useRef,
    useState
} from 'react'
import _ from 'lodash';
import {withRouter, Prompt} from 'react-router-dom';
import classNames from 'classnames';
import appConfig from 'app-config';
import { useTranslator } from '@jutro/locale';
import {MetadataContent} from '@jutro/legacy/uiconfig';
import {useModal} from '@jutro/components';
import {useAuthentication} from '@xengage/gw-digital-auth-react';
import {AccountService} from 'gw-capability-gateway-policy';
import {useDataRefresh, ViewModelServiceContext} from '@xengage/gw-portals-viewmodel-react';
import {LoadSaveService, GatewayEmailQuoteService} from 'gw-capability-gateway-quoteandbind';
import {GatewayDocumentService} from 'gw-capability-gateway-document';
import { MLNewQuoteDialogModal, MLNewQuoteDialogModalMessages, MLUWIssuesPanelComponent } from 'gw-capability-gateway-quoteandbind-common-react';
import {messages as commonMessages} from '@xengage/gw-platform-translations';
import {MLBundleService, MLHistoryService} from 'ml-services-common-react';
import {UserService} from 'gw-capability-gateway';
import {MLLOBDisplayService} from 'ml-portals-services-js';
import {MLModalService, MLTagManagerService} from 'ml-portals-services-react';
import {DocumentDownloadService} from '@xengage/gw-portals-document-js';
import {FormModalPopover, platformMessages} from 'ml-components-platform-react';
import {TrackEvent, Identify} from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/TrackEvent';
import { MLActivityDateUtil } from 'ml-portals-util-react';
import { MLErrorMessageUtil } from 'ml-portals-util-js';
import { MLPortalSettingsService} from 'gw-capability-quoteandbind';
import metadata from './MLBundleCart.metadata.json5';

import messages from './MLBundleCart.messages';
import styles from './MLBundleCart.module.scss';

import { IntlContext } from '@jutro/legacy/locale';

function MLBundleCart(props) {
    const modalApi = useModal();
    const intl = useContext(IntlContext);
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const {
        history,
        match,
        location,
        bridgedQuoteData
    } = props;

    const isFromCompRater = bridgedQuoteData ? bridgedQuoteData.isFromCompRater : false;
    const trackingPageName = (isFromCompRater) ? 'CR Landing Page' : 'Agent Bundle Cart'
    const accountNumber = isFromCompRater ? bridgedQuoteData?.accountNumber : match.params.accountNumber;
    const [isModernProduct, setIsModernProduct] = useState(false);
    const [userType,setUserType]= useState(undefined);
    const QUOTE_ASSIST = 'Quote Assist';

    const {
        state: {
            hasExistingSubmissions_ML,
            isBundleRetrieval_Ext
        } = {}
    } = location;

     const {MLUserTypes, MLCustomHistoryTypes} = appConfig;
     const { IA } = MLUserTypes;
     const validUserType = [IA];
    const bridgedQuotes = props?.location?.state?.bridgedQuotes;
    const baseState = bridgedQuotes?.[0]?.baseState;
    const {
        showProgressDialog,
        hideProgressDialog,
        showErrorModal
     } = MLModalService();

    const {
        toLocaleTimeStamp
    } = MLActivityDateUtil();

    const {refreshData} = useDataRefresh();
    const {authHeader, authUserData} = useAuthentication();

    const DOWN_PAYMENT_ERROR_MSG = 'Payment must be received prior to issuing policy';
    const [submissions, updateSubmissions] = useState([]);
    const [requotingArray, updateRequotingArray] = useState([]);
    const [bundleValidationErrors, updateBundleValidationErrors] = useState([]);
    const [bundleUwIssues, updateBundleUwIssues] = useState([]);
    const [errorMessages, updateErrorMessages] = useState([]);
    const [warningMessages, updateWarningMessages] = useState([]);
    const [isValideDate , updatedIsValideDate]=useState(true);
    const [loading, setLoading] = useState(false);
    const [issuing, setIssuing] = useState(false);
    const [packageIndicatorChangedFlag, setPackageIndicatorChangedFlag] = useState(false);
    const [newProductStates, updateNewProductStates] = useState([]);
    const [enablePackageIndicator, setEnablePackageIndicator] = useState(false);
    const hasAutoMoveToPostQuoteTriggered = useRef(false);
    const isQnB = appConfig.portalCode === 'QB';
    const [isProducerCodeUpdateToGroupID, setisProducerCodeUpdateToGroupID] = useState(false);

    const termTypeLabels = {
        Annual: messages.annual,
        HalfYear: messages.halfYear
    };

    useEffect(() => {
        MLPortalSettingsService.getSettings(authHeader).then((response)=> {
            if (response) {
                setEnablePackageIndicator(response.enablePackageIndicator_Ext)
            }
        });
    }, [authHeader]);

    useEffect(() => {
      MLPortalSettingsService.getSettings(authHeader).then((response) => {
        if (response) {
          setisProducerCodeUpdateToGroupID(
            response.enableProducerCodeToGroupId_Ext,
          );
        }
      });
    }, [authHeader]);

    const _resetMessages = (type) => {
        if (type) {
            if (type === 'error') {
                updateErrorMessages([]);
            } else if (type === 'warning') {
                updateWarningMessages([]);
            }
        } else if (type === undefined) {
            updateErrorMessages([]);
            updateWarningMessages([]);
        }
    };

    const _addMessage = (type, key, message, job) => {
        if (type) {
            let auxMessages;
            let messagesUpdater;
            if (type === 'error') {
                auxMessages = errorMessages;
                messagesUpdater = updateErrorMessages;
            } else if (type === 'warning') {
                auxMessages = warningMessages;
                messagesUpdater = updateWarningMessages;
            } else {
                auxMessages = [];
                messagesUpdater = _.noop;
            }
            const idx = _.findIndex(auxMessages, ['key', key]);
            if (idx > -1) {
                const clonedMessages = [...auxMessages];
                clonedMessages[idx].message = message;
                messagesUpdater(clonedMessages);
            } else {
                const clonedMessages = [...auxMessages];
                clonedMessages.push({'key': key, 'job': job, 'message': message});
                messagesUpdater(clonedMessages);
            }
        }
    };

    const _showBookrollBundleMessage = () => {
        _addMessage('warning', 'bookrollBundle', translator(messages.reminderCustomerPreviouslyQuoted));
    };

    const isBundleEffectiveDateEditable = (sub) => {
        return sub.bookrollIndicator_ML === "No" || _.isNil(sub.bookrollIndicator_ML) || !inPostQuote() || sub.bookrollIndicator_ML === QUOTE_ASSIST;
    }

    const _updateBundleUwIssues = () => {
        const auxBundleUwIssues = [];
        submissions.forEach((sub) => {
            if (sub.hasIssues_ML && sub.validQuote) {
                sub.uwissues.forEach((issue) => {
                    issue.jobNumber = sub.jobNumber;
                    auxBundleUwIssues.push(issue);
                });
            }
        });
        updateBundleUwIssues(auxBundleUwIssues);
    };

    const _areAllQuoted = (subs) => {
        return subs && !subs.some((x) => !MLBundleService.isQuoted(x));
    };

    const isPA = (submission) => {
        return submission.policyLines[0].lineOfBusinessCode === MLLOBDisplayService.LOB.PERSONAL_AUTO;
    };

    const isHO = (submission) => {
        return submission.policyLines[0].lineOfBusinessCode === MLLOBDisplayService.LOB.HOMEOWNERS;
    };

    const isPUP = (submission) => {
        return submission.policyLines[0].lineOfBusinessCode === MLLOBDisplayService.LOB.UMBRELLA;
    };

    const _checkForRequoteMessage = () => {
        if (submissions && submissions.length > 0) {
            window.scrollTo(0, 0);
            if (MLBundleService.getNumberPackageIndicatorRequotes() > 0) {
                if (MLBundleService.getNumberPackageIndicatorRequotes() === 1) {
                    const index = submissions.findIndex((sub) => sub.publicID === MLBundleService.getPackageIndicatorRequoteId(0));
                    if (isPUP(submissions[index])) {
                        _addMessage('warning', 'requoteNeeded', translator(messages.informationMayHaveChangedOnULPolicies));
                    } else {
                        _addMessage('error', 'requoteNeeded', translator(messages.packageIndicatorChangedRequote));
                        setPackageIndicatorChangedFlag(true);
                    }
                } else {
                    _addMessage('error', 'requoteNeeded', translator(messages.packageIndicatorChangedRequote));
                    setPackageIndicatorChangedFlag(true);
                }
                return;
            }
            submissions.forEach((sub) => {
                if (MLBundleService.isRequoteNeeded(sub)) {
                    _addMessage('warning', 'requoteNeeded', translator(messages.policiesNeedRequote));
                }
            });
        }
    };

    const areAllQuoted = () => {
        return _areAllQuoted(submissions);
    };

    const hasIssues = () => {
        return (bundleValidationErrors && bundleValidationErrors.length > 0) || (bundleUwIssues && bundleUwIssues.length > 0);
    };

    const hasValidationErrors = () => {
        return bundleValidationErrors && bundleValidationErrors.length > 0;
    };

    const canStartQuote = (submission) => {
        if (!isPUP(submission)) {
            return true;
        }
        const allOtherSubmissions = submissions.filter((aSubmission) => aSubmission.jobNumber !== submission.jobNumber);
        return _areAllQuoted(allOtherSubmissions);
    };

    const areAllCompleted = () => {
        return submissions && submissions.every((x) => x.postQuoteComplete);
    };

    const inPostQuote = () => {
        return submissions && submissions.some((x) => x.readyForPostQuote || x.postQuoteStarted || x.postQuoteComplete);
    };

    const createBundleQuote = () => {
        const isQuotedStatus = submissions && submissions?.some(item => !item?.validQuote)
        return !isQuotedStatus;
    }

    const canPrintProposal = () => {
        if (MLBundleService.isBookrollBundle()) {
            return submissions && submissions.every((x) => MLBundleService.isQuoted(x));
        }
        return !inPostQuote() && submissions && submissions.length > 1 && submissions.filter(
            (x) => MLBundleService.isQuoted(x) || MLBundleService.isQuotedWithIssues(x)).length > 1;
    };

    const validNumberOfJobs = () => {
        return isFromCompRater ? submissions && submissions.length >= 1 : submissions && submissions.length >= 2;
    };

    const inReadyPurchase = () => {
        return (areAllQuoted() || inPostQuote()) && !hasIssues() && validNumberOfJobs();
    };

    const isProducerAutoUpdatedForBundle = useCallback((sourceSubmissions = []) => {
        return Array.isArray(sourceSubmissions) && sourceSubmissions.some((submission) => {
            const producerAutoUpdated = submission?.producerAutoUpdated_Ext;
            return producerAutoUpdated === true;
        });
    }, []);

    const isSubRequoting = (submission) => {
        return requotingArray.indexOf(submission.publicID) > -1;
    };

    const isRequotingOccuring = () => {
        return requotingArray.length > 0;
    };

    const getSubmissionDescription = (submission) => {
        return submission.jobDescription;
    };

    const getLOBPolicyName = (submission) => {
        if (isHO(submission)) {
            return `${MLLOBDisplayService.getLOBPolicyName(submission)} (${submission.baseState})`;
        }
        return MLLOBDisplayService.getLOBPolicyName(submission);
    };

    const emailQuote = (sessionInfo, isBundleProposal) => {

        const {emailAddress1} = sessionInfo;

        const promise = GatewayEmailQuoteService.emailQuote(sessionInfo, isBundleProposal, authHeader);
        showProgressDialog(platformMessages.generatingQuoteProposal, promise);
        promise.then(() =>
        {
            setTimeout(() => {
                showErrorModal(
                    '',
                    translator(messages.emailQuoteDescription, {emailAddress_ML: emailAddress1}),
                    null
                ).catch(_.noop);
            }, 100);
        }).catch(() => {
            showErrorModal(
                messages.error,
                messages.proposalError,
                commonMessages.ok
            ).catch(_.noop);
        });
    };


    const printQuote = (quoteID, isBundled) => {
        // EventHub.publish('wizard', 'print');
        const periodID = undefined;
        const createProposalPromise = LoadSaveService.createQuoteProposal(quoteID, periodID, isBundled, authHeader);
        showProgressDialog(platformMessages.generatingQuoteProposal, createProposalPromise);
        createProposalPromise.then((data) => {
            const docUid = data.docUID;
            const sessionId = data.sessionID;
            const publicId = data.publicID;
            if (docUid) {
                // const docUrl = `${serviceBaseURLs.pc}document/gateway/document/${publicId}?token=${sessionId}`;
               GatewayDocumentService.downloadDocument(publicId, sessionId);
            } else {
                modalApi.showAlert({
                    title: messages.error,
                    message: messages.proposalError,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
            }
        }).catch(error => {
            // US1113547: Handle CDCE Exceptions error
            hideProgressDialog();
            MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
        });
    };

    const createProposalForAgentType = (quoteID, email, isBundled, sessionUUID) => {
        printQuote(quoteID, isBundled);
    };

    const createProposal = () => {
        const isBundled = true;
        const email = submissions[0].accountHolder_ML.emailAddress1;
        const quoteId = submissions[0].jobNumber;
        const sessionUUID = submissions[0].sessionUUID;
        createProposalForAgentType(quoteId, email, isBundled, sessionUUID);
    };


    const goToAccount = () => {
        UserService.getCurrentUser(authHeader).then((user) => {
            TrackEvent('Cta Clicked', user, { action: `${trackingPageName} Go To Account`, accountNumber: accountNumber});
        })
        history.push(`/accounts/${accountNumber}/summary`);
    };

    const markJobsForPrequote = (saveStatus) => {
        MLBundleService.markJobsForPrequote(saveStatus, authHeader);
        refreshData();
    };

    const _isIssuanceDownPaymentError = (error) => {
        return error.includes(DOWN_PAYMENT_ERROR_MSG);
    };

    const _formatErrorMessage = (jobNumber, errorMsg) => {
        if (!jobNumber) {
            return errorMsg;
        }
        const prefix = translator(messages.submissionHashtag);
        return `${prefix}${jobNumber} - ${errorMsg}`;
    };

    const parseErrorForMessage = (error) => {
        const errorToConvert = error.replace("[", "").replace("]", "");
        const errorparsed = errorToConvert.split(',');
        return errorparsed;
    };

    const _addValidationErrorMessages = (error) => {
        const auxBundleValidationErrors = [];
        const errorParsed = parseErrorForMessage(error);
        if (errorParsed) {
            errorParsed.forEach((err) => {
                auxBundleValidationErrors.push(err);
            });
        } else {
            auxBundleValidationErrors.push(error);
        }
        updateBundleValidationErrors(auxBundleValidationErrors);
    };

    const _handleBundleError = (error, isIssuanceError) => {
        if (!isIssuanceError) {
            MLBundleService.markJobsForPrequote(true, authHeader);
        }
        const nestedError = error?.error?.error || error?.error;
        if (nestedError?.message) {
            const nestedErrorCode = Number(nestedError.code);
            const nestedErrorMessage = nestedError.message;
            const displayMessageMatch = nestedErrorMessage.match(/>:\s*(.*?)\s*\|\s*ErrorCode:/);
            const displayMessage = displayMessageMatch ? displayMessageMatch[1] : nestedErrorMessage;
            if (nestedErrorCode === -32603) {
                _addMessage('error', displayMessage, displayMessage, null);
            } else {
                _addMessage('error', 'genericError', translator(messages.genericErrorMessage));
            }
        } else {
            const errorMessagePrefix = 'ErrorMessage:';
            const errorMessageCode = 'ErrorCode:';
            const stackTraceCode = 'StackTrace_ML:';
            const messageTraceCode = 'Messages_ML:';
            const empty = '';
            const space = ' ';

            const errorMessageStringArray = error.baseError.split(space);
            const errorMessageIndex = errorMessageStringArray.lastIndexOf(errorMessagePrefix);
            const errorMessageValue = errorMessageIndex !== -1 ? errorMessageStringArray[errorMessageIndex + 1] : undefined;

            const innerErrorCodeIndex = errorMessageStringArray.lastIndexOf(errorMessageCode);
            const innerErrorCodeValue = innerErrorCodeIndex !== -1 ? errorMessageStringArray[innerErrorCodeIndex + 1] : undefined;
            const innerErrorCodeNumericValue = !_.isUndefined(innerErrorCodeValue) ? parseInt(innerErrorCodeValue, 10) : undefined;
            const indexOfStackTrace = error.baseError.lastIndexOf(stackTraceCode);
            const baseErrorLastString = indexOfStackTrace === -1 ? messageTraceCode : stackTraceCode;
            let errorMessage;
            const SplitMessageContent = errorMessageValue.includes("&gt;:") ? "&gt;:" : ">:";

            if (error.baseError.lastIndexOf(errorMessagePrefix) > -1 && error.baseError.lastIndexOf(baseErrorLastString) > -1) {
                errorMessage = error.baseError.slice(error.baseError.lastIndexOf(errorMessagePrefix), error.baseError.lastIndexOf(baseErrorLastString))
                    .replace(errorMessagePrefix, empty)
                    .trim();
            }

            if(errorMessage.includes(SplitMessageContent)){
                errorMessage = errorMessage.split(SplitMessageContent)[1].trim();
            }

            if (innerErrorCodeNumericValue === -31000 &&  error.baseError.includes('ERROR-804')) {
                _addMessage('error', 'moveToPostQuote', translator(messages.packageIndicatorChangedRequote));
                setPackageIndicatorChangedFlag(true);
                MLBundleService.setPackageIndicatorRequoteJobs();
            } else if (innerErrorCodeNumericValue === -31000 && error.baseError.includes('ERROR-803')) {
                _addMessage('error', 'bundleError', errorMessage.replace("ERROR-803:", empty).trim());
            } else if (innerErrorCodeNumericValue === -31000 && errorMessage) {
                _addValidationErrorMessages(errorMessage);
            } else if (innerErrorCodeNumericValue === -32603 && errorMessage) {
                _addMessage('error', errorMessage, errorMessage, null);
            } else {
                _addMessage('error', 'genericError', translator(messages.genericErrorMessage));
            }
        }
        const promise = MLBundleService.refreshBundleSummary(accountNumber, authHeader).then(() => {
            _updateBundleUwIssues();
        });
        showProgressDialog(messages.retrievingBundle, promise);
    };


    const executeMoveToPostQuote = () => {
        const promise = MLBundleService.canMoveToPostQuote(accountNumber, authHeader).then((canMoveToPostQuote) => {
            if(!enablePackageIndicator){
                if (!canMoveToPostQuote) {
                    _addMessage('error', 'moveToPostQuote', translator(messages.packageIndicatorChangedRequote));
                    setPackageIndicatorChangedFlag(true);
                    return MLBundleService.refreshBundleSummary(accountNumber, authHeader);
                }
            }
            const bundleJobs = MLBundleService.getJobs();
            return MLBundleService.getPostQuoteStatusForJobs(authHeader).then((responses) => {
                responses.forEach((response, index) => {
                    const job = bundleJobs[index];
                    if (job) {
                        if (response && typeof response === 'string') {
                            const responseObj = JSON.parse(response);
                            job.postQuoteStarted = responseObj.postQuoteStarted ? responseObj.postQuoteStarted : false;
                            job.postQuoteComplete = responseObj.postQuoteComplete ? responseObj.postQuoteComplete : false;
                            job.readyForPostQuote = !(job.postQuoteStarted || job.postQuoteComplete);
                        } else {
                            job.readyForPostQuote = true;
                            job.postQuoteStarted = false;
                            job.postQuoteComplete = false;
                        }
                    }
                });

                updateSubmissions([...bundleJobs]);

                _resetMessages();
                MLTagManagerService.sendBundleEvent('formStep',
                    {form: 'Purchase Bundle Product', stepName: 'Continue to purchase'});

                const requests = submissions.map((submission) => {
                    return {
                        jobNumber: submission.jobNumber,
                        sessionUUID: submission.sessionUUID,
                        eventType: MLCustomHistoryTypes.QuoteAccepted
                    };
                });
                MLHistoryService.createHistoryEvents(requests, authHeader);

            });

        }).catch((error) => {
            _handleBundleError(error);
        });
        showProgressDialog(messages.retrievingBundle, promise);
    };

    const showProducerAutoUpdatedAcknowledgementModal = useCallback((shouldShowProducerModal, onAcknowledge) => {
        if (!isProducerCodeUpdateToGroupID || !shouldShowProducerModal) {
            onAcknowledge();
            return;
        }

        const componentProps = {
            title: translator(messages.producerCodeAcknowledgementTitle),
            CustomComponent: () => <div>{translator(messages.producerCodechanged)}<br/><br/>{translator(messages.producerCodechangedAdditionalText)}<br/><br/>{translator(messages.producerCodechangedAssistanceText)}</div>,
            actionBtnLabel: translator(messages.acknowledgeAndContinue),
            cancelBtnLabel: translator(messages.cancelModalBtn),
            showFooterOnCustomComponent: true,
            showActionButton: true,
            onSaveAction: () => true
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        ).then(() => {
            onAcknowledge();
        }).catch(_.noop);
    }, [isProducerCodeUpdateToGroupID, modalApi, translator]);

    const moveToPostQuote = (shouldCheckProducerAutoUpdated = true) => {
        if (!shouldCheckProducerAutoUpdated) {
            executeMoveToPostQuote();
            return;
        }

        const promise = MLBundleService.refreshBundleSummary(accountNumber, authHeader).then(() => {
            const latestSubmissions = MLBundleService.getJobs() || [];
            updateSubmissions([...latestSubmissions]);

            const shouldShowProducerModal = isProducerAutoUpdatedForBundle(latestSubmissions);

            MLTagManagerService.sendBundleEvent('producerAutoUpdatedModalDecision', {
                accountNumber,
                shouldShowProducerModal,
                submissionCount: latestSubmissions.length
            });

            showProducerAutoUpdatedAcknowledgementModal(shouldShowProducerModal, () => {
                executeMoveToPostQuote();
            });
        }).catch((error) => {
            _handleBundleError(error);
        });

        showProgressDialog(messages.retrievingBundle, promise);
    };

    const showNewQuoteDialog = (account) => {
        const accountVM = viewModelService.create(account, 'pc', 'edge.capabilities.gateway.account.dto.AccountDTO');
        const overrides = {
            model: accountVM,
            history
        };

        const componentProps = {
            title: translator(MLNewQuoteDialogModalMessages.startAQuote),
            overrideProps: overrides,
            CustomComponent: MLNewQuoteDialogModal,
            buttonType: 'secondary',
            showFooterOnCustomComponent: false,
            additionalPEStyle: 'customFooterModal',
            viewModelService,
            authHeader
        };
        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        ).then(() => {
            const promise = MLBundleService.refreshBundleSummary(accountNumber, authHeader).then(() => {
                updateSubmissions(MLBundleService.getJobs());
                _resetMessages();

            }).catch((error) => {
                _handleBundleError(error);
            });

            showProgressDialog(messages.retrievingBundle, promise);
        });
    };

    const addNewComponent = () => {
        const accountPromise = AccountService.getAccountDetails(accountNumber, authHeader);
        showProgressDialog(messages.retrievingAccountDetails, accountPromise);

        UserService.getCurrentUser(authHeader).then((user) => {
            TrackEvent('Cta Clicked', user, {action: `${trackingPageName} Add Product`, accountNumber: accountNumber});
        })

        accountPromise.then((account) => {
            showNewQuoteDialog(account)
        });
    };

    const startBundleIssuanceProcess = () => {
        setIssuing(true);
        const promise = MLBundleService.startIssuance(accountNumber, authHeader).then(() => {
            history.push(`/bundle-confirmation/${accountNumber}`);
            setIssuing(false);
        }).catch((error) => {
            _handleBundleError(error, true);
        });

        showProgressDialog(messages.issuingBundledPolicies, promise);
    };

    const _clearValidationErrorMessagesForSubmission = (jobNumber) => {
        return bundleValidationErrors.filter((msg) => msg.indexOf(jobNumber) === -1);
    };

    const _updateValidationErrorMessages = (sub) => {
        const auxBundleValidationErrors = _clearValidationErrorMessagesForSubmission(sub.jobNumber);
        if (sub.validationErrors_ML) {
            sub.validationErrors_ML.forEach((error) => {
                auxBundleValidationErrors.push(_formatErrorMessage(sub.jobNumber, error));
            });
        }
        updateBundleValidationErrors([...auxBundleValidationErrors])
    };

    const requoteSubmission = (submission) => {
        const auxRequotingArray = [...requotingArray];
        auxRequotingArray.push(submission.publicID);
        updateRequotingArray(auxRequotingArray);
        const requotePromise = MLBundleService.requoteSubmission(submission.jobNumber, authHeader);
        showProgressDialog(messages.requoting, requotePromise);
        try {
            requotePromise.then((job) => {
                const index = submissions.findIndex((sub) => sub.publicID === job.publicID);
                if (index > -1) {
                    submissions[index] = job;
                }
                const ind = auxRequotingArray.indexOf(job.publicID);
                if (ind > -1) {
                    auxRequotingArray.splice(ind, 1);
                }
                MLBundleService.removePackageIndicatorRequoteJob(job.publicID);
                updateRequotingArray(auxRequotingArray);
                _resetMessages();
                _updateValidationErrorMessages(job);
                _updateBundleUwIssues();
                _checkForRequoteMessage();
            }).catch((error) => {
                console.error(error);
                const params = {
                    ...error,
                    accountNumber: accountNumber,
                    quoteID: submission.jobNumber
                };
                history.push('/contactUs', params);
            });
        } catch {
            hideProgressDialog();
        }
    };

    const resumeQuote = (quote, edit) => {
        const quoteEntryInfo = {
            quoteID: quote.jobNumber,
            postalCode: quote.address_ML.postalCode,
            account: quote.accountNumber,
            editBundle: edit,
            isBundle_ML: submissions.length > 1,
            hasExistingSubmissions_ML: hasExistingSubmissions_ML,
            agentCompRaterStartEditingQuote: isFromCompRater ? true : undefined,
            editSubmissionFromBundle: true
        };

        UserService.getCurrentUser(authHeader).then((user) => {
            TrackEvent('Cta Clicked', user, {action: `${trackingPageName} Edit Quote`, quoteDetails: quote});
        })

        if (!quoteEntryInfo.isBundle_ML) {
            const promise = MLBundleService.removeJobFromBundle(quote.jobNumber, authHeader).then(() => {
                history.push('/quoteentry', quoteEntryInfo);
            }).catch(error => {
                // US1172141: Handle CDCE Exceptions error
                hideProgressDialog();
                MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
            });
            showProgressDialog(messages.refreshingBundle, promise);
            return;
        }

        if ((isPA(quote) || isHO(quote)) && MLBundleService.hasQuotedUmbrellaJob() && !MLBundleService.isBookrollBundle()) {
            MLBundleService.resetUmbrellaToDraftStatus(accountNumber, authHeader);
            // To determine if the BundleCart Screen is from Comprator flow
            if (submissions.some((item) => item.isCompRaterRequest_ML === true)) {
                // To make submission to go to Quote Page if it is quoted and isfromComprator rather than to BQS
                quoteEntryInfo.agentCompRaterStartEditingQuote = true
            }
        }
        MLBundleService.removePackageIndicatorRequoteJob(quote.publicID);
        MLBundleService.markJobsForPrequote(true, authHeader);
        history.push('/quoteentry', quoteEntryInfo);
    };

    const resumePostQuote = (quote, isPurchasing) => {
        const quoteEntryInfo = {
            quoteID: quote.jobNumber,
            postalCode: quote.address_ML.postalCode,
            account: quote.accountNumber,
            editBundle: true,
            isBundle_ML: true,
            hasExistingSubmissions_ML: hasExistingSubmissions_ML,
            canSkipPurchaseSteps: !!quote.postQuoteStarted,
            agentCompRaterStartEditingQuote: (isFromCompRater ||submissions.some((item) => item.isCompRaterRequest_ML === true)) ? true : undefined,
            isPurchasing,
        };
        MLBundleService.setJobPostQuoteStarted(quote.jobNumber, authHeader);
        history.push('/quoteentry', quoteEntryInfo);
    };

    const refreshBundleUwIssues = () => {
        const promise = MLBundleService.refreshBundleSummary(accountNumber, authHeader).then(() => {
            _updateBundleUwIssues();
        });
        showProgressDialog(messages.refreshingBundle, promise);
    };

    const initSettings = useCallback(() => {
        MLPortalSettingsService.getSettings(authHeader).then((response) => {
            if (response) {
                updateNewProductStates(response.enableAuto50ProductStates);
            }
        });
    }, [authHeader]);

    useEffect(() => {
          UserService.getCurrentUser(authHeader).then((user) => {
            setUserType(user.userType);
          });

        initSettings();
    }, []);
    
    useEffect(() => {
        if (newProductStates.includes(baseState)) {
            setIsModernProduct(true);
        } else {
            setIsModernProduct(false);
        } 
    }, [baseState, newProductStates]);

    useEffect(() => {
        if (isFromCompRater) {
            const submissionNumber = bridgedQuoteData.submissions[0]?.jobNumber ?? "";
            const promise = MLBundleService.refreshBridgedQuoteSummaries(submissionNumber, authHeader).then(() => {
                const loadedJobs = MLBundleService.getJobs();
                updateSubmissions(loadedJobs);
                UserService.getCurrentUser(authHeader).then((user) => {
                    TrackEvent('Landing Page Reached', user, {bridgedSubmissions: bridgedQuoteData.submissions});
                });

            }).catch((error) => {
                _handleBundleError(error);
            });
            showProgressDialog(messages.retrievingBundle, promise);
        } else {
            const promise = MLBundleService.refreshBundleSummary(accountNumber, authHeader).then(() => {
                const loadedJobs = MLBundleService.getJobs();
                updateSubmissions(loadedJobs);

            }).catch((error) => {
                _handleBundleError(error);
            });

            showProgressDialog(messages.retrievingBundle, promise);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        Identify('Bundle Cart Reached', {step: 'bundle cart'}, null)
    }, [])

    const _canMovePostQuote = () => {
        return inReadyPurchase() && !MLBundleService.isBookrollBundle();
    };

    const displayCompRaterQuote = (quote) => {
        return quote.isCompRaterRequest_ML === true && quote.totalPremium.amount === 0 && quote.compRaterPremium_ML !== undefined && !packageIndicatorChangedFlag;
    };

    const getFormattedCompRaterQuote = (sub, intlparam) => {
        const compRaterQuotePremium = sub?.compRaterPremium_ML
        return MLBundleService.formatPremium(compRaterQuotePremium, intlparam)
    }

    useEffect(() => {
        _updateBundleUwIssues();
        if (MLBundleService.isBookrollBundleWithRateCapping()) {
            _showBookrollBundleMessage();
        } else {
            _checkForRequoteMessage();
        }

        if (_canMovePostQuote() && isBundleRetrieval_Ext && !hasAutoMoveToPostQuoteTriggered.current) {
            hasAutoMoveToPostQuoteTriggered.current = true;
            moveToPostQuote(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submissions]);


    const getBundleValidationErrors = () => {
        return (
            <React.Fragment>
                {bundleValidationErrors.map((error, index, array) => {
                    return (
                        <React.Fragment>
                            {error}
                            {index < array.length - 1 && <br/>}
                        </React.Fragment>
                    );
                })}
            </React.Fragment>
        );
    };

    const getValidationErrors = () => {
        return (
            <React.Fragment>
                <p>{translator(messages.issuesWithQuotesCorrectToProceed)}</p>
                {bundleValidationErrors.length > 0 &&
                    <p className="vertical-spacing-0 padding-bottom-0">{getBundleValidationErrors()}</p>
                }
            </React.Fragment>
        );
    }

    const generateMessages = () => {
        const generatedMessages = [];
        errorMessages.forEach((error) => {
            generatedMessages.push({
                type: 'error',
                message: `${(error.job) ? `${error.job}: ` : ''} ${error.message}`,
                className: "alert-error",
                wrapperClassName: "wrapper-error"
            });
        })
        warningMessages.forEach((warning) => {
            generatedMessages.push({
                type: 'warning',
                message: `${(warning.job) ? `${warning.job}: ` : ''} ${warning.message}`,
                className: "alert-warning",
                wrapperClassName: "wrapper-warning"
            });
        })
        return generatedMessages;
    }

    const getLOBOffering = (submission) => {
        return submission.coveragePackageLevel_Ext ? submission.coveragePackageLevel_Ext : '';
    }

    const writeValue = useCallback((value, path, sub,index)=>{
        _.set(sub, path, value);
        submissions[index] = sub;
        updateSubmissions(submissions);
        refreshData();
    },[refreshData, submissions])

    const updateBundleCartEffectiveDate = useCallback((sub) => {
        // to avoid saving the date if it is notValid
        if (_.isUndefined(sub.policyEffectiveDate_ML) || !isValideDate) {
            return
        }
        const GW_POLICYLOCKED_EXCEPTION = 'PolicyLockedExceptionML';
        const promise = MLBundleService.updateBundleCartEffectiveDate({ jobNumber: sub.jobNumber, effectiveDate: sub.policyEffectiveDate_ML, isFromCompRater: isFromCompRater }, authHeader)
         .catch((error) => {
            hideProgressDialog();
            if(error.baseError && error.baseError.includes(GW_POLICYLOCKED_EXCEPTION)){
                showErrorModal(
                messages.error,
                messages.policyLockedExceptionMessage,
                commonMessages.close
                ).catch(_.noop);
            } else {
                // US1064387: Handle CDCE Exceptions error
                 MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
            }
        });
        showProgressDialog(messages.refreshingBundle, promise);
        promise.then(() => {
            updateSubmissions([...MLBundleService.getJobs()]);
            refreshData();
        });
        
    }, [authHeader, hideProgressDialog, isFromCompRater, isValideDate, refreshData, showErrorModal, showProgressDialog])

    const handleOnUnbundled = useCallback((sub) => {
        const promise = MLBundleService.removeJobFromBundle(sub.jobNumber, authHeader).then(() => {
            return MLBundleService.refreshBundleSummary(accountNumber, authHeader).then(() => {
                const res = MLBundleService.getJobs();
                if(res.length === 1){
                    const isStarted_ML = res[0].isStarted_ML
                    if(isStarted_ML){
                        return resumeQuote(res[0],true);
                    } 
                    return resumeQuote(res[0]);
                }
               return  updateSubmissions(res);
            })
        }).catch(error => {
            // US1113547: Handle CDCE Exceptions error
            hideProgressDialog();
            MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
        });

        showProgressDialog(messages.refreshingBundle, promise);
    }, [accountNumber, authHeader, resumeQuote, showProgressDialog])

    const generateSubmissionOverrides = useCallback(() => {
        const overrides = submissions.map((sub, index) => {
            return {
                [`agentBundleCartSubmissionLobIcon${index}`]: {
                    className: classNames(
                        'pull-left',
                        'position-absolute',
                        {
                            'icon-icon-car-white': isPA(sub),
                            'icon-foremost-umbrella-icon': isPUP(sub),
                            'icon-ml-home-detailed-icon': isHO(sub)
                        }
                    )
                },
                [`agentBundleCartSubmissionLobTextTitle${index}`]: {
                    content: `${getLOBPolicyName(sub)} ${getLOBOffering(sub)}`
                },
                [`agentBundleCartSubmissionLobTextDescription${index}`]: {
                    content: getSubmissionDescription(sub)
                },
                [`agentBundleCartSubmissionLobTextJobNumber${index}`]: {
                    content: `#${sub.jobNumber}`
                },
                [`agentBundleCartSubmissionLobTextTimeStamp${index}`]: {
                     content: `${toLocaleTimeStamp(sub.editTime_ML)}`,
                     visible: isFromCompRater
                },
                [`agentBundleCartSubmissionLobTextRCIcon${index}`]: {
                    visible: sub.bookrollIndicator_ML === 'With Rate Capping',
                    title: translator(messages.rateCapped)
                },
                [`agentBundleCartSubmissionLobTextNRCIcon${index}`]: {
                    visible: sub.bookrollIndicator_ML === 'Without Rate Capping',
                    title: translator(messages.nonRateCapped)
                },
                [`agentBundleCartSubmissionPremium${index}`]: {
                    content: !displayCompRaterQuote(sub) ? MLBundleService.formatSubmissionPremium(sub, intl) : getFormattedCompRaterQuote(sub, intl)
                },
                [`agentBundleCartSubmissionPremiumTerm${index}`]: {
                    content: translator(termTypeLabels[sub.termType_ML])
                },
                [`agentBundleCartSubmissionEffectiveDate${index}`]: {
                    value: sub.policyEffectiveDate_ML,
                    required:true,
                    onValueChange: (value, path) => writeValue(value, path, sub, index),
                    onValidationChange:(value)=>updatedIsValideDate(value),
                    onBlur: () => updateBundleCartEffectiveDate(sub),
                    labelPosition: isFromCompRater ? "top" : "left",
                    readOnly : !isBundleEffectiveDateEditable(sub),
                    // to restrict the user to select the effective date only upto 90 days
                    maxDate: new Date(new Date().getTime()+(90*24*60*60*1000)),
                },
                [`agentBundleCartSubmissionStatus${index}`]: {
                    content: MLBundleService.getStatus(sub).displayName
                },
                [`agentBundleCartSubmissionPreQuoteStatusIconContainer${index}`]: {
                    visible: !inPostQuote()
                },
                [`agentBundleCartSubmissionPreQuoteStatusIcon${index}`]: {
                    className: classNames({
                        'status-0': MLBundleService.isNotStarted(sub),
                        'status-50': MLBundleService.isDraft(sub),
                        'status-100-check': MLBundleService.isQuoted(sub),
                        'status-warning': MLBundleService.isRequoteNeeded(sub),
                        'status-error': MLBundleService.isQuotedWithIssues(sub)
                    })
                },
                [`agentBundleCartSubmissionPostQuoteStatusIconContainer${index}`]: {
                    visible: inPostQuote()
                },
                [`agentBundleCartSubmissionPostQuoteStatusIcon${index}`]: {
                    className: classNames({
                        'status-0': MLBundleService.isPrePurchase(sub) || MLBundleService.isPurchaseStarted(sub),
                        'status-100-check': MLBundleService.isReadyToIssue(sub),
                        'status-error': MLBundleService.isQuotedWithIssues(sub)
                    })
                },
                [`agentBundleCartSubmissionBtnContainer${index}`]: {
                    visible: !isSubRequoting(sub)
                },
                [`agentBundleCartSubmissionBtnPreQuote${index}`]: {
                    visible: !inPostQuote() && !MLBundleService.isBookrollBundleWithRateCapping()
                },
                [`agentBundleSubmissionBtnStart${index}`]: {
                    visible: MLBundleService.isNotStarted(sub),
                    disabled: !canStartQuote(sub) || isRequotingOccuring(),
                    onClick: () => { resumeQuote(sub) }
                },
                [`agentBundleSubmissionBtnEditQuote${index}`]: {
                    visible: !MLBundleService.isNotStarted(sub) && !MLBundleService.isRequoteNeeded(sub),
                    disabled: !canStartQuote(sub) || isRequotingOccuring(),
                    onClick: () => resumeQuote(sub, true)
                },
                [`agentBundleSubmissionBtnEdit${index}`]: {
                    visible: !MLBundleService.isNotStarted(sub) && MLBundleService.isRequoteNeeded(sub),
                    disabled: !canStartQuote(sub) || isRequotingOccuring(),
                    onClick: () => resumeQuote(sub, true)
                },
                [`agentBundleSubmissionBtnRequote${index}`]: {
                    visible: !MLBundleService.isNotStarted(sub) && MLBundleService.isRequoteNeeded(sub),
                    disabled: !canStartQuote(sub),
                    onClick: () => requoteSubmission(sub, true)
                },
                [`agentBundleCartSubmissionBtnPostQuote${index}`]: {
                    visible: inPostQuote() && !MLBundleService.isBookrollBundleWithRateCapping()
                },
                [`agentBundleSubmissionBtnCompletePurchaseInfo${index}`]: {
                    visible: sub.readyForPostQuote || sub.postQuoteStarted,
                    disabled: isRequotingOccuring(),
                    onClick: () => resumePostQuote(sub, true)
                },
                [`agentBundleSubmissionBtnEditPurchaseInfo${index}`]: {
                    visible: sub.postQuoteComplete,
                    disabled: isRequotingOccuring(),
                    onClick: () => resumePostQuote(sub, false)
                },
                [`agentBundleCartSubmissionBtnBookroll${index}`]: {
                    visible: MLBundleService.isBookrollBundleWithRateCapping()
                },
                [`agentBundleSubmissionBtnViewQuote${index}`]: {
                    disabled: !MLBundleService.isQuoted(sub),
                    onClick: () => resumeQuote(sub)
                },
                [`agentBundleCartSubmissionLoadingContainer${index}`]: {
                    visible: isSubRequoting(sub)
                },
                [`agentBundleCartSubmissionPremiumContainer${index}`]: {
                    visible: !isFromCompRater
                },
                [`agentCompRaterSubmissionPremiumContainer${index}`]: {
                    visible: isFromCompRater
                },
                [`agentBundleCartSubmissionLobTextLob${index}`]: {
                    content: `${getLOBPolicyName(sub)}: `
                },
                [`agentBundleCartSubmissionPremiumTitleContainer${index}`]: {
                    visible: displayCompRaterQuote(sub)
                },
                [`agentBundleCartUnbundledComponentBtn${index}`]: {
                    onClick: () => handleOnUnbundled(sub),
                    visible : submissions.length > 1 && !inPostQuote()                                                                                      
                },
            }
        });

        return Object.assign({}, ...overrides);
    }, [canStartQuote, getLOBPolicyName, updateBundleCartEffectiveDate, handleOnUnbundled, inPostQuote, intl, isFromCompRater, isRequotingOccuring, isSubRequoting, requoteSubmission, resumePostQuote, resumeQuote, submissions, termTypeLabels, translator, writeValue]);

    const wrapAndTranslateMessage = (message) => {
        return (
            <React.Fragment>
                {translator(message, {
                    strong: (chunks) => <strong>{chunks}</strong>
                })}
            </React.Fragment>)
    }

    const generatedMessages = generateMessages();

    const overrideProps = {
        agentBundleCartBackToEditLink: {
            visible: inPostQuote() && !MLBundleService.isBookrollBundleWithRateCapping()
        },
        agentBundleCartUWIssues: {
            visible: bundleUwIssues.length > 0 && !MLBundleService.isBookrollBundle(),
            uwIssues: bundleUwIssues,
            showIssuesForBundle: true,
            refreshBundleUwIssues: refreshBundleUwIssues,
            wrapped: true
        },
        agentBundleCartValidationErrors: {
            visible: hasValidationErrors(),
            message: getValidationErrors()
        },
        agentBundleCartMessagesContainer: {
            data: generatedMessages,
            visible: generatedMessages.length > 0
        },
        agentBundleCartNotReadyForPurchaseSectionHeaderContainer: {
            visible: !inReadyPurchase() && !inPostQuote()
        },
        agentBundleCartNotReadyForPurchaseCompleteAll: {
            visible: validNumberOfJobs()
        },
        agentBundleCartNotReadyForPurchaseTwoJobsMinimum: {
            visible: !validNumberOfJobs()
        },
        agentBundleCartReadyForPurchaseSectionHeaderContainer: {
            visible: inReadyPurchase() && !inPostQuote()
        },
        agentBundleCartPostQuoteSectionHeaderContainer: {
            visible: inPostQuote()
        },
        agentBundleCartSubmissionFakeContainer: {
            data: submissions
        },
        agentBundleCartAddComponentRowContainer: {
            visible: !inPostQuote()
        },
        agentBundleAddComponentBtn: {
            disabled: isRequotingOccuring(),
            mlTagManagerLinkClick: "Add/Remove Product"
        },
        agentBundleGoToAccountBtn: {
            disabled: isRequotingOccuring(),
            mlTagManagerLinkClick: "Go to Account"
        },
        agentBundleCreateProposalBtnContainer: {
            visible: canPrintProposal()
        },
        agentBundleCreateProposalBtn: {
            visible: createBundleQuote(),
            disabled: isRequotingOccuring(),
            mlTagManagerLinkClick: "View Bundle Quote"
        },
        agentBundleCartGoToAccountRowContainer: {
            visible: inPostQuote()
        },
        agentBundleGoToAccountBtn2: {
            disabled: isRequotingOccuring(),
            mlTagManagerLinkClick: "Go to Account"
        },
        agentBundleCartContinuePurchaseBtn: {
            visible: !inPostQuote(),
            disabled: !inReadyPurchase() || !validNumberOfJobs() || isRequotingOccuring() || MLBundleService.isBookrollBundleWithRateCapping(),
            className: isQnB ? "primaryButton" : ""
        },
        agentBundleCartIssueBundleBtn: {
            visible: inPostQuote(),
            disabled: !areAllCompleted() || hasIssues() || isRequotingOccuring() || MLBundleService.isBookrollBundleWithRateCapping() || issuing
        },
        agentBundleCartContinuePurchaseMessage: {
            visible: validNumberOfJobs() && !inPostQuote(),
            content: wrapAndTranslateMessage(messages.continueToPurchaseMessage)
        },
        agentBundleCartCompletePurchaseMessage: {
            visible: inPostQuote() && !areAllCompleted(),
            content: wrapAndTranslateMessage(messages.completePurchaseMessage)
        },
        agentBundleCartIssuePoliciesMessage: {
            visible: inPostQuote() && areAllCompleted(),
            content: wrapAndTranslateMessage(messages.issuePoliciesMessage)
        },
        agentBundleCartAddComponentMessage: {
            visible: !validNumberOfJobs(),
            content: wrapAndTranslateMessage(messages.addComponentToContinue)
        },
        agentBundleCartHeader: {
            content: isFromCompRater ? translator(messages.bridgedQuotesSummary) : translator(messages.bundleCart)
        },
        agentBundleCartFooter: {
            visible: !isFromCompRater
        },
        ...generateSubmissionOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            addNewComponent,
            goToAccount,
            createProposal,
            moveToPostQuote,
            startBundleIssuanceProcess,
            markJobsForPrequote,
        },
        resolveComponentMap: {
            MLUWIssuesPanelComponent: MLUWIssuesPanelComponent
        }
    };

    const handleOnCancel = (_location) => {
        if (_location.pathname === "/" ||
            _location.pathname.startsWith("/new-quote-account-search") ||
            _location.pathname.startsWith("/search/"))
        {
            const title = translator(messages.exitModalTitle);
            const message = translator(messages.exitModalMessage);
            setLoading(true);

            modalApi.showModal(
                <FormModalPopover
                    title={title}
                    simpleMessage={message}
                    actionBtnLabel={commonMessages.yes}
                    cancelBtnLabel={platformMessages.mlCancel}
                    closeSimpleMessage={false}
                />
            ).then(() => {
                history.push(_location);
            }).catch(() => {
                setLoading(false);

            });
            return false;
        }
        return true;

    }

    return <>
        <Prompt when={!loading} message={handleOnCancel}/>
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            {...resolvers} />
    </>;
}

export default withRouter(MLBundleCart);